import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">关于天堂影院</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            一个专注于高清不缓冲、流畅在线观影的品质平台
          </p>
        </div>
        <div className="bg-background-100 rounded-xl border border-background-200/60 p-6 md:p-10">
          <div className="space-y-4 mb-10">
            {aboutData.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-4 md:gap-6">
            {aboutData.stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-4 md:p-6 rounded-xl bg-background-50 border border-background-200/40"
              >
                <div className="text-2xl md:text-3xl font-heading text-accent-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}